import { render, staticRenderFns } from "./CBlock.vue?vue&type=template&id=11bb7132&"
import script from "./CBlock.ts?vue&type=script&lang=ts&"
export * from "./CBlock.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports